import { TextConfigDefault } from './nb-NO';

export const daDK: TextConfigDefault = {
  common: {
    tryAgain: 'Prøv igen',
    contactUs: 'Kontakt os',
    loginIn: 'Log ind på Mit Altibox',
    forgotPassword: 'Glemt adgangskode',
    notACustomer: 'Ikke kunde endnu? Bliv kunde',
    becomeAcustomer: 'Bliv kunde',
    back: '< Tilbage',
  },
  crmBlocked: {
    title: 'Beklager!',
    ingress: 'Grundet vedligehold er det ikke muligt at registrere ny bruger på nuværende tidspunkt. Prøv igen på et senere tidspunkt!',
    emoji: '😑',
    emojiLabel: 'uttrykksløs-emoji',
    description: '',
  },
  systemError: {
    title: 'Uha..',
    ingress: 'Her gik det <strong>helt galt</strong>',
    emoji: '💩',
    emojiLabel: 'Bæsj-emoji',
  },
  timeOut: {
    title: 'For mange forsøg',
    ingress: 'Prøv igen om <strong>10 minutter</strong>',
    emoji: '😬',
    emojiLabel: 'Grimase-emoji',
    description:
      'For at sikre dine og andre kunders data, tillader vi ikke mere end 10 forsøg i løbet af 10 minutter. Forsøg igen senere, eller tag kontakt til os, hvis du har behov for hjælp.',
  },
  userCreated: {
    title: 'Tjek din indbakke!',
    ingress: 'Vi har <strong>sendt dig en e-mail</strong> med instruktioner om oprettelse af adgangskode:',
    emoji: '✉️',
    emojiLabel: 'Brev-emoji',
  },
  pinSent: {
    title: 'Tjek din indbakke!',
    ingress: 'Din PIN-kode er sendt til din e-mailadresse. Tryk på knappen nedenfor for at komme tilbage til oprettelse af bruger.',
    emoji: '✉️',
    emojiLabel: 'Brev-emoji',
    createUserButton: 'Opret bruger',
  },
  userCreateFailed: {
    title: 'Ups!',
    ingress: 'Beklager. En <strong>fejl</strong> hos os.',
    emoji: '😬',
    emojiLabel: 'Grimase-emoji',
    description: 'Tag kontakt, hvis fejlen ikke forvinder, men først:',
  },
  userExist: {
    title: 'Hej igen!',
    ingress: 'Du <strong>er allerede oprettet som bruger</strong>.',
    emoji: '🤗',
    emojiLabel: 'Klemmefjes-emoji',
  },
  userMultipleMatches: {
    title: 'Ups...',
    ingress: 'Vi fandt <strong>flere kundeforhold</strong> med din e-mailadresse:',
    emoji: '🤓😎',
    emojiLabel: 'Nerdefjes-emoji og Solbrillefjes-emoji',
    description: 'Vores systemer kan desværre ikke se hvem der er hvem. Du skal derfor have hjælp fra os til at fuldføre processen.',
  },
  mailVerificationSent: {
    title: 'Tjek din indbakke!',
    ingress: 'Vi har sendt dig en ny e-mail. Følg instruktionerne i e-mailen for at gennemføre registreringen.',
    emoji: '✉️',
    emojiLabel: 'Brev-emoji',
  },
  userNotFound: {
    title: 'Hmmm...',
    ingress: 'Vi <strong>fandt dig ikke</strong> med nedenstående oplysninger',
    emoji: '🤔',
    emojiLabel: 'Tenkefjes-emoji',
    partnerLabel: 'Elselskab:',
    phoneLabel: 'Mobilnummer:',
    emailLabel: 'E-mailadresse:',
    customerNumberLabel: 'Kundenummer:',
    pinLabel: 'PIN-kode:',
  },
  userSubmit: {
    title: 'Få adgang',
    ingress: 'Lad os finde dig i vores systemer.',
    formfieldPhoneLabel: 'Mobilnummer',
    formfieldEmailLabel: 'E-mailadresse',
    formfieldCustomerNumberLabel: 'Kundenummer',
    formfieldPinLabel: 'PIN-kode',
    formSubmitButtonText: 'Gå videre',
    legacyHelp: 'Dit kundenummer kan du finde på din faktura eller ordrebekræftelse.',
    legacyPinLink: 'Har du ikke en PIN-kode?',
  },
  pinVerified: {
    defaultTitle: 'Fandt dig!',
    titlePersonalized: 'Hej, {accountFirstName}!',
    ingress: 'Her skal du indtaste din e-mailadresse og vælge en adgangskode',
    emoji: '🤗',
    emojiLabel: 'Klemmefjes-emoji',
    buttonSubmitText: 'Opret bruger',
    formfieldEmailLabel: 'E-mailadresse',
    formfieldPasswordLabel: 'Adgangskode',
    formValidationFeedback: {
      emailInvalid: 'E-mailadressen er ikke gyldig. Har du indtastet den rigtig?',
      passwordInvalid: 'Adgangskoden er for svag',
    },
    passwordRules: 'Adgangskoden skal bestå af mindst 8 tegn og indeholde: tal, specielle tegn, store bokstaver og små bokstaver.',
    passwordOk: 'Adgangskoden er godkendt',
    showPasswordLabel: 'Vis',
    hidePasswordLabel: 'Skjul',
    capsLockWarning: 'NB! Caps lock er slået til!',
    usernameTaken: 'E-mailadressen er allerede registreret',
  },
  offCode: {
    title: 'Næsten færdig!',
    ingress: 'Vi har sendt dig en e-mail for at bekræfte e-mailadressen. Du kan trykke på linket i e-mailen, eller indsætte koden her:',
    emoji: '✉️',
    emojiLabel: 'Brev-emoji',
    offcodeLabel: 'Engangskode:',
    buttonSubmitText: 'Bekræft',
    formValidationFeedback: {
      offcode: 'Koden må være på 5 cifre.',
    },
    invalidOffcode: 'Forkert kode. Tjek at du har skrevet den rigtigt.',
  },
  userFinalized: {
    title: 'Succes!',
    ingress: 'Bruger oprettet! Nu kan du logge ind på Mit Altibox',
    emoji: '🥳',
    emojiLabel: 'Fest-emoji',
    buttonText: 'Gå til Mit Altibox',
  },
  spinner: {
    pleaseWait: 'Venligst vent',
  },
  apiAuthenticationErrors: {
    NoAccessableAccount: 'Doesn\'t match any accessible account', // 6001
    MissingInput: 'Missing input', // 6002
    UserNotAuthenticated: 'User not authenticated', // 6003
  },
  forgotPin: {
    title: 'Mangler du din PIN-kode?',
    emoji: '🤔',
    emojiLabel: 'Tenkefjes-emoji',
    ingress:
      'Vælg dit lokale elselskab og indtast dit kundenummer for at få tilsendt din PIN-kode til din registrerede e-mailadresse - Dit kundenummer kan du finde på din faktura eller ordrebekræftelse.',
    buttonText: 'Send mig PIN-kode',
    formCustomerNumberLabel: 'Dit kundenummer',
    invalidCustomerNumber: 'Kundenummeret er ikke gyldigt. Har du skrevet det rigtigt?',
  },
  partnerSelect: {
    label: 'Vælg dit lokale elselskab',
    defaultOptionText: '-- Vælg elselskab --',
    validationMessage: 'Du skal vælge dit lokale fibernet.',
  },
  validationSummary: {
    title: 'Hmm, der er noget som ikke er helt rigtigt.',
    formValidationFeedback: {
      partnerNumberInvalid: 'Du må vælge dit lokale fibernet.',
      mobileNumberInvalid: 'Mobilnummer skal være på 8 cifre.',
      emailInvalid: 'E-mailadressen er ikke gyldig. Har du skrevet den rigtig?',
      customerNumberInvalid: 'Kundenummeret er ikke gyldigt. Har du skrevet det rigtigt?',
      pinInvalid: 'PIN-koden er ikke gyldig. Den skal være på 4 cifre.',
    },
  },
  cardHeader: {
    altiboxUrl: 'https://www.altibox.dk/',
    logoAlt: 'Til forsiden af altibox.dk',
  },
};
